import {
	MessageBackend as createMessageBackendConfluenceCreateASpace,
	MessageFrontend as createMessageFrontendConfluenceCreateASpace,
} from '@post-office/message-template--confluence-create-a-space/placements/in-app-v2/confluence-side-nav';
import {
	MessageBackend as createMessageBackendConfluenceResurrectedUserWelcomeSideBarNudge,
	MessageFrontend as createMessageFrontendConfluenceResurrectedUserWelcomeSideBarNudge,
} from '@post-office/message-template--confluence-resurrected-user-welcome-sidebar-nudge/placements/in-app-v2/confluence-side-nav';
import {
	MessageBackend as createMessageBackendConfluenceSideNav1On1LoomNudge,
	MessageFrontend as createMessageFrontendConfluenceSideNav1On1LoomNudge,
} from '@post-office/message-template--confluence-side-nav-1-on-1-loom-nudge/placements/in-app-v2/confluence-side-nav';
import {
	MessageBackend as createMessageBackendConfluenceSideNavCreateASpace,
	MessageFrontend as createMessageFrontendConfluenceSideNavCreateASpace,
} from '@post-office/message-template--confluence-side-nav-create-a-space/placements/in-app-v2/confluence-side-nav';
import {
	MessageBackend as createMessageBackendLoomAiMeetingNotesInConfluence,
	MessageFrontend as createMessageFrontendLoomAiMeetingNotesInConfluence,
} from '@post-office/message-template--loom-ai-meeting-notes-in-confluence/placements/in-app-v2/confluence-side-nav';
import {
	MessageBackend as createMessageBackendConfluenceCreateWithRovoSideNavNudge,
	MessageFrontend as createMessageFrontendConfluenceCreateWithRovoSideNavNudge,
} from '@post-office/message-template--confluence-create-with-rovo-side-nav-nudge/placements/in-app-v2/confluence-side-nav';
import {
	MessageBackend as createMessageBackendRovoExtensionInstallCta,
	MessageFrontend as createMessageFrontendRovoExtensionInstallCta,
} from '@post-office/message-template--rovo-extension-install-cta-left-nav/placements/in-app-v2/confluence-side-nav';
import {
	MessageBackend as createMessageBackendTwcSidenavBanner,
	MessageFrontend as createMessageFrontendTwcSidenavBanner,
} from '@post-office/message-template--twc-sidenav-banner/placements/in-app-v2/confluence-side-nav';
import { productionRuntime } from '@post-office/placement-common-v2/placement-runtime';
import {
	PlacementBackend,
	PlacementFrontend,
} from '@post-office/placements--growth/confluence-side-nav';

const messageBackends = [
	createMessageBackendConfluenceCreateASpace({ messageTemplateId: 'confluence-create-a-space' }),
	createMessageBackendConfluenceSideNavCreateASpace({
		messageTemplateId: 'confluence-side-nav-create-a-space',
	}),
	createMessageBackendConfluenceSideNav1On1LoomNudge({
		messageTemplateId: 'confluence-side-nav-1-on-1-loom-nudge',
	}),
	createMessageBackendLoomAiMeetingNotesInConfluence({
		messageTemplateId: 'loom-ai-meeting-notes-in-confluence',
	}),
	createMessageBackendConfluenceResurrectedUserWelcomeSideBarNudge({
		messageTemplateId: 'confluence-resurrected-user-welcome-sidebar-nudge',
	}),
	createMessageBackendConfluenceCreateWithRovoSideNavNudge({
		messageTemplateId: 'confluence-create-with-rovo-side-nav-nudge',
	}),
	createMessageBackendRovoExtensionInstallCta({
		messageTemplateId: 'rovo-extension-install-cta-left-nav',
	}),
	createMessageBackendTwcSidenavBanner({ messageTemplateId: 'twc-sidenav-banner' }),
];

const messageFrontends = [
	createMessageFrontendConfluenceCreateASpace({ messageTemplateId: 'confluence-create-a-space' }),
	createMessageFrontendConfluenceSideNavCreateASpace({
		messageTemplateId: 'confluence-side-nav-create-a-space',
	}),
	createMessageFrontendConfluenceSideNav1On1LoomNudge({
		messageTemplateId: 'confluence-side-nav-1-on-1-loom-nudge',
	}),
	createMessageFrontendLoomAiMeetingNotesInConfluence({
		messageTemplateId: 'loom-ai-meeting-notes-in-confluence',
	}),
	createMessageFrontendConfluenceResurrectedUserWelcomeSideBarNudge({
		messageTemplateId: 'confluence-resurrected-user-welcome-sidebar-nudge',
	}),
	createMessageFrontendConfluenceCreateWithRovoSideNavNudge({
		messageTemplateId: 'confluence-create-with-rovo-side-nav-nudge',
	}),
	createMessageFrontendRovoExtensionInstallCta({
		messageTemplateId: 'rovo-extension-install-cta-left-nav',
	}),
	createMessageFrontendTwcSidenavBanner({ messageTemplateId: 'twc-sidenav-banner' }),
];

export const placementBackendFactory = PlacementBackend.createPlacementBackend({
	messageTemplates: messageBackends,
});

export const Placement = PlacementFrontend.createPlacementFrontendComponent({
	messageTemplates: messageFrontends,
});

export const middleware = placementBackendFactory(productionRuntime);
